import { Component, forwardRef, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sbnb-color-picker',
  templateUrl: './color-picker.component.html',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true,
    },
  ],
})
export class ColorPickerComponent implements ControlValueAccessor {
  colorOptions = input<{ color: string; value: string | number; name?: string }[]>([
    {
      color: '#ffeeeb',
      value: 0,
    },
    {
      color: '#8c41001a',
      value: 1,
    },
    {
      color: '#FEF6EE',
      value: 2,
    },
    {
      color: '#FFF9E5',
      value: 3,
    },
    {
      color: '#F0FAF5',
      value: 4,
    },
    {
      color: '#F0F9FF',
      value: 5,
    },
    {
      color: '#FAF5FF',
      value: 6,
    },
    {
      color: '#FFF0F2',
      value: 7,
    },
  ]);

  value: string | number | null = null;
  onChange: (value: string | number | null) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: string | number | null): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string | number | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  selectColor(value: string | number): void {
    this.value = value;
    this.onChange(this.value);
    this.onTouched();
  }
}
